import React from 'react';

import { QuestionBubble } from '../QuestionBubble';
import { TestID } from './constants';

const MatchStatusQuestionBubble: React.FC = () => (
  <QuestionBubble
    dataTestID={TestID}
    popoverTitle="Match Status"
    sections={[
      {
        sectionTitle: 'New Match',
        sectionBody:
          'These clients are new matches. We recommend a first outreach within 24 hrs and a second outreach before 72 hours. After 7 days, we will move this client to inactive if they have not chatted or booked a session.',
      },
      {
        sectionTitle: 'Engaged',
        sectionBody:
          'These clients have chatted, or booked sessions in the past 2 weeks. They may need some follow-up since your last interaction.',
      },
      {
        sectionTitle: 'Active',
        sectionBody:
          'These clients have chatted, or booked sessions within the past 2 months, but not in the past 2 weeks. These clients are likely to benefit from a follow up message.',
      },
      {
        sectionTitle: 'Inactive',
        sectionBody:
          "New matches who are unresponsive after 1 week are considered inactive. Additionally, clients who previously booked or chatted, but haven't in 2 months are considered inactive.",
      },
      {
        sectionTitle: 'Unmatched',
        sectionBody:
          "These clients are no longer matched and you won't be able to interact with them.",
      },
    ]}
  />
);

export default MatchStatusQuestionBubble;
